import take from './take.js';

/**
 * Same as {@link take}.
 * @function head
 */
const head = take;
export default head;
